import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnauthorizedLoadGuard } from '@core';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { MyOrdersComponent } from './pages';

const routes: Routes = [
  {
    canLoad: [UnauthorizedLoadGuard],
    canActivate: [NgxPermissionsGuard],
    path: '',
    component: MyOrdersComponent,
    data: {
      permissions: {
        only: ['customer', 'seller'],
        redirectTo: '',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
